import { useMemo } from 'react'
import settings from 'settings'

// create a hook to detect if the app is running in SaaS or self-hosted mode
export function useCartoVersion() {
  // wrap in useMemo to avoid re-rendering

  const versionInfo = useMemo(() => {
    return {
      isSaaS: settings.cartoVersion === 'SaaS',
      isSH: settings.cartoVersion !== 'SaaS',
      version: settings.cartoVersion
    }
  }, [])
  return versionInfo
}
